import { c as _c } from "react/compiler-runtime";
import { MenuItem, Select, Typography } from '@mui/material';
export const DateTimePropertySelector = t0 => {
  const $ = _c(11);
  const {
    selectedValue,
    onValueChange,
    options
  } = t0;
  let t1;
  if ($[0] !== options) {
    t1 = value => <Typography variant="subtitle1" className="font-medium">{options.find(option => option.value === value)?.label}</Typography>;
    $[0] = options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onValueChange) {
    t2 = e => onValueChange(e.target.value);
    $[2] = onValueChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== options) {
    t3 = options.map(_temp);
    $[4] = options;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== selectedValue || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <Select variant="standard" value={selectedValue} renderValue={t1} onChange={t2}>{t3}</Select>;
    $[6] = selectedValue;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
function _temp(option_0) {
  return <MenuItem key={option_0.value} value={option_0.value}>{option_0.label}</MenuItem>;
}